// 03/11/2026 (registre n° 38) : modèles de messages communs à tous les utilisateurs.
// Gardés par le service Demandes reçues (même domaine : /__recues/api/modeles/<clé>, comptes ADMIN),
// avec le jeton de la personne connectée. En cas d'échec, l'appelant garde le texte d'origine.
const BASE = "/__recues/api/modeles/";

const entetes = () => {
  let t = null;
  try { t = window.localStorage.getItem("token"); } catch (e) { /* stockage indisponible */ }
  return t ? { Authorization: "Bearer " + t } : {};
};

const reponse = (r) =>
  r.json().catch(() => ({})).then((j) => {
    if (!r.ok) throw new Error(j.erreur || "erreur " + r.status);
    return j;
  });

export const lireModele = (cle) =>
  fetch(BASE + encodeURIComponent(cle), { headers: entetes(), cache: "no-store" }).then(reponse);

export const enregistrerModele = (cle, texte) =>
  fetch(BASE + encodeURIComponent(cle), {
    method: "POST",
    headers: Object.assign({ "Content-Type": "application/json" }, entetes()),
    body: JSON.stringify({ texte }),
  }).then(reponse);



// WEBPACK FOOTER //
// ./src/store/external/modeles.js